import {Component, ElementRef, Injectable, TemplateRef, ViewContainerRef} from '@angular/core';
import {TemplatePortal} from "@angular/cdk/portal";
import {Overlay} from "@angular/cdk/overlay";
import {Subscription} from "rxjs";
import {NavigationStart, Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class DropDownMenuService {
  globalOverlay = this.overlay.create({
    hasBackdrop: true,
    backdropClass: 'transparent-overlay-back-drop',
  });

  constructor(
    private overlay: Overlay,
    private router: Router,
  ) {
    this.globalOverlay.backdropClick().subscribe(() => this.hide());
  }

  show(origin: ElementRef<Component>, menuTemplate: TemplateRef<Component>, vcRef: ViewContainerRef) {
    const dropDownMenuTemplatePortal = new TemplatePortal(menuTemplate, vcRef);

    // dropDownMenuを表示している状態でブラウザバックが行われた場合に閉じる処理
    const routerEventSubscription: Subscription = this.router.events.subscribe((event) => {
      if(event instanceof NavigationStart) {
        this.hide();
      }
    });

    // dropDownMenuがdetachされた際に呼ばれるコールバック
    const overlayEventSubscription: Subscription = this.globalOverlay.detachments().subscribe(() => {
      overlayEventSubscription.unsubscribe();
      routerEventSubscription.unsubscribe();
    });

    if (!this.globalOverlay.hasAttached()) {
      this.globalOverlay.updatePositionStrategy(
        this.overlay.position().flexibleConnectedTo(origin).withPositions([
          {
            originX: 'center',
            originY: 'bottom',
            overlayX: 'center',
            overlayY: 'top',
            offsetY: 15,
          }
        ])
      );

      this.globalOverlay.attach(dropDownMenuTemplatePortal);
    }
  }

  hide() {
    if (this.globalOverlay.hasAttached()) {
      this.globalOverlay.detach();
    }
  }

  toggle(origin: ElementRef<Component>, menuTemplate: TemplateRef<Component>, vcRef: ViewContainerRef) {
    if (!this.globalOverlay.hasAttached()) {
      this.show(origin, menuTemplate, vcRef);
    } else {
      this.hide();
    }
  }
}
